module.exports = __webpack_public_path__ + "img/nallaisideimage.5d899379.png";